import * as React from 'react';

const useVariantSwitcher = ({ variants , initialSku  })=>{
    const [activeSku, setActiveSku] = React.useState(initialSku);
    const activeVariant = variants.find((variant)=>variant.sku === activeSku
    );
    const handleVariantChange = (sku)=>{
        if (sku) {
            setActiveSku(sku);
        }
    };
    return {
        activeSku,
        activeVariant,
        handleVariantChange
    };
};

export { useVariantSwitcher };
//# sourceMappingURL=use-variant-switcher.js.map
